export const menuConfig = [
  {
    title: "Operations",
    submenu: [
      { name: "Outage", path: "/outages" },
      { name: "management", path: "/management" },
    ],
    tabs: [
      { name: "Outages", key: "Outages", icon: "FiAlertTriangle" },
    ],
    charts: [
      { key: "OutagesChart", label: "Outages Chart" },
    ],
    tables: [
      { key: "OutagesTable", label: "Outages Table" },
    ],
  }
];
